import OldHeader from '@/website/components/Header';

export default function Header(props?: any) {
  return <OldHeader {...props} />;
}
